import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import ChatContainer from './components/ChatContainer';
import InstructionsContainer from './components/InstructionsContainer';
import MovieDisplay from './components/MovieDisplay';
import BackButtonContainer from './components/BackButtonContainer';
import ProcessingModal from './components/ProcessingModal';
import LandingPage from './components/LandingPage';
import { Analytics } from "@vercel/analytics/react";

function App() {
  const [page, setPage] = useState('landing'); // 'landing', 'chat', or 'movies'
  const [allMovies, setAllMovies] = useState([]);
  const [displayedMovies, setDisplayedMovies] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageHistory, setPageHistory] = useState([]);
  const [processing, setProcessing] = useState(false);

  // Function to go back to homepage
  const goToHomePage = () => {
    setPage('landing');
  };

  // Function to show chat interface
  const showChat = () => {
    setPage('chat');
  };

  // Function to display movie results
  const showMovies = (movies, allResults) => {
    setDisplayedMovies(movies);
    setAllMovies(allResults);
    setPage('movies');
    setCurrentPage(0);
    setPageHistory([]);
  };

  // Function to go back to chat
  const resetChat = () => {
    setPage('chat');
    setAllMovies([]);
    setDisplayedMovies([]);
    setCurrentPage(0);
    setPageHistory([]);
  };

  return (
    <div className={`App ${page === 'movies' ? 'movies-visible' : ''}`}>
      <Navbar goToHomePage={goToHomePage} />
      
      {page === 'landing' && (
        <LandingPage showChat={showChat} />
      )}
      
      {page === 'chat' && (
        <>
          <ChatContainer 
            showMovies={showMovies}
            setProcessing={setProcessing}
          />
          <InstructionsContainer />
        </>
      )}
      
      {page === 'movies' && (
        <>
          <MovieDisplay movies={displayedMovies} />
          <BackButtonContainer 
            resetChat={resetChat}
            hasMore={allMovies.length > (currentPage + 1) * 8}
            showPrevious={pageHistory.length > 0}
            loadMoreMovies={() => {
              if (currentPage === 0) {
                setPageHistory([]);
              }
              
              setPageHistory([...pageHistory, currentPage]);
              const nextPage = currentPage + 1;
              
              if (nextPage * 8 < allMovies.length) {
                setCurrentPage(nextPage);
                const start = nextPage * 8;
                const end = start + 8;
                setDisplayedMovies(allMovies.slice(start, end));
              } else {
                // Loop back to beginning
                setCurrentPage(0);
                setDisplayedMovies(allMovies.slice(0, 8));
              }
            }}
            showPreviousMovies={() => {
              if (pageHistory.length > 0) {
                const prevPage = pageHistory[pageHistory.length - 1];
                setPageHistory(pageHistory.slice(0, -1));
                setCurrentPage(prevPage);
                
                const start = prevPage * 8;
                const end = start + 8;
                setDisplayedMovies(allMovies.slice(start, end));
              }
            }}
          />
        </>
      )}
      
      <ProcessingModal visible={processing} />
      <Analytics />
    </div>
  );
}

export default App;
